export const translations = {
  'Customer service': { de_DE: 'Kundenservice', nl_NL: 'Klantenservice' },
  Design: { de_DE: 'Design', nl_NL: 'Ontwerp' },
  'Good promotions': { de_DE: 'Gute Aktionen', nl_NL: 'Goede acties' },
  'How satisfied are you with our site?': {
    de_DE: 'Wie zufrieden bist du mit unserer Seite?',
    nl_NL: 'Hoe tevreden ben je met onze website?'
  },
  'Ordering process': { de_DE: 'Bestellprozess', nl_NL: 'Bestelprocedure' },
  Other: { de_DE: 'Sonstiges', nl_NL: 'Miscellaneous' },
  'Page layout': { de_DE: 'Seitenaufbau', nl_NL: 'Paginaopmaak' },
  'Please choose at least one Topic': {
    de_DE: 'Bitte wählen Sie zumindest ein Topic aus'
  },
  'Price/Performance': { de_DE: 'Preis/Leistung', nl_NL: 'Prijs/prestatie' },
  'Problem with coupon / offer': {
    de_DE: 'Problem mit Gutschein/Angebot',
    nl_NL: 'Probleem met voucher/aanbieding'
  },
  'Product availability': {
    de_DE: 'Produktverfügbarkeit',
    nl_NL: 'Beschikbaarheid van het product'
  },
  'Product information': {
    de_DE: 'Artikelinformationen',
    nl_NL: 'Product Information'
  },
  'Product quality': {
    de_DE: 'Produktqualität',
    nl_NL: 'Kwaliteit van het product'
  },
  'Product selection': {
    de_DE: 'Produktauswahl',
    nl_NL: 'Selectie van producten'
  },
  Search: { de_DE: 'Suchfunktion', nl_NL: 'Zoekfunctie' },
  'Send feedback': { de_DE: 'Feedback senden' },
  Shipping: { de_DE: 'Versand', nl_NL: 'Verzending' },
  'Simple ordering process': {
    de_DE: 'Einfacher Bestellprozess',
    nl_NL: 'Eenvoudig bestelproces'
  },
  'Sorry, something went wrong.': {
    de_DE: 'Tut uns leid, da lief etwas schief.',
    nl_NL: 'Sorry, daar is iets mis gegaan.'
  },
  'Technical issue': {
    de_DE: 'Technischer Fehler',
    nl_NL: 'Technische fouten'
  },
  'Tell us briefly what makes you happy or what we could improve.': {
    de_DE: 'Verrate uns kurz, was dich glücklich macht oder wir noch verbessern könnten.',
    nl_NL: 'Vertel ons kort wat je gelukkig maakt of wat we kunnen verbeteren.'
  },
  'Thank you for taking your time. We are constantly working to improve our site.': {
    de_DE:
      'Danke, dass du dir Zeit genommen hast. Wir arbeiten daran, unsere Seite stets weiter zu verbessern.',
    nl_NL: 'Bedankt voor het nemen van de tijd. We werken voortdurend aan de verbetering van onze website.'
  },
  'Thank you for taking your time. We will be entitled to our site as soon as possible.': {
    de_DE: 'Danke, dass du dir Zeit genommen hast. Wir werden unsere Seite schnellstmöglich verbessern.',
    nl_NL: 'Bedankt voor het nemen van de tijd. Wij zullen onze website zo snel mogelijk verbeteren.'
  },
  'There seems to be a technical problem blocking the sending of your feedback. We have already been automatically informed of this error and will correct it as soon as possible.':
    {
      de_DE:
        'Es scheint ein technisches Problem zu geben, dass das Absenden deines Feedbacks blockiert. Wir wurden bereits automatisch über diesen Fehler informiert und werden ihn schnellstmöglich beheben.',
      nl_NL:
        'Er lijkt een technisch probleem te zijn dat het versturen van je feedback blokkeert. Wij zijn al automatisch op de hoogte gebracht van deze fout en zullen deze zo spoedig mogelijk oplossen.'
    },
  'Tips, tools & recipes': {
    de_DE: 'Tipps, Tools & Rezepte',
    nl_NL: 'Tips, tools & recepten'
  },
  'We are glad to hear that!': {
    de_DE: 'Das freut uns zu hören!',
    nl_NL: 'We zijn blij om dat te horen!'
  },
  'We hope you enjoy shopping!': {
    de_DE: 'Wir wünschen dir noch viel Spaß beim Shoppen!',
    nl_NL: 'Wij wensen je veel plezier bij het winkelen!'
  },
  'What can we do better?': {
    de_DE: 'Was können wir besser machen?',
    nl_NL: 'Wat houdt je bezig?'
  },
  'Your feedback is on the way!': {
    de_DE: 'Dein Feedback ist auf dem Weg!!',
    nl_NL: 'Jouw feedback is onderweg!'
  },

  "If you have any problems with your order, payment or voucher codes, write to us using the <a href='%s'> contact form </a>.":
    {
      de_DE:
        "Bei Problemen rund um deine Bestellung, Bezahlung oder Gutscheincodes, schreib uns über das <a href='%s'>Kontaktformular</a>."
    },
  'Is your concern urgent?': { de_DE: 'Ist dein Anliegen dringend?' },
  'Mo - Fr 10:00 to 18:00': { de_DE: 'Mo - Fr 10:00 bis 18:00 Uhr' },
  'Please describe your problem to us in more detail (anonymous feedback).': {
    de_DE: 'Beschreibe uns dein Problem gerne etwas genauer (anonymes Feedback).'
  },
  'Your Message': { de_DE: 'Dein Kommentar' },
  "or via <a href='%s'>contact form</a>": {
    de_DE: "oder per <a href='%s'>Kontaktformular</a>"
  }
};
